import { CountryInterface } from "../interfaces/country-interface";

export const Countries: CountryInterface[] = [
    { name: "Argentina", code: "AT", id: "1055" },
    { name: "Australia", code: "AU", id: "1062"  },
    { name: "Brazil", code: "BZ", id: "1060" },
    { name: "Canada", code: "CN", id: "1063" },
    { name: "China", code: "CH" , id: "1058" },
    { name: "Denmark", code: "DN" , id: "1039" },
    { name: "England", code: "GB" , id: "1003" },
    { name: "Finland", code: "FN" , id: "1014" },
    { name: "France", code: "FR" , id: "1004" },
    { name: "Germany", code: "GR" , id: "1029" },
    { name: "Greece", code: "GR" , id: "1021" },
    { name: "Hong Kong", code: "HK" , id: "1103" },
    { name: "India", code: "IND" , id: "1080" },
    { name: "Ireland", code: "IR" , id: "1030" },
    { name: "Italy", code: "IT" , id: "1017" },
    { name: "Japan", code: "IT" , id: "1059" },
    { name: "Luxembourg", code: "IT" , id: "1047" },
    { name: "Mexico", code: "IT" , id: "1056" },
    { name: "Netherlands", code: "IT" , id: "1048" },
    { name: "Paraguay", code: "IT" , id: "1099" },
    { name: "Poland", code: "IT" , id: "1013" },
    { name: "Portugal", code: "IT" , id: "1016" },
    { name: "Romania", code: "IT" , id: "1051" },
    { name: "Russia", code: "IT" , id: "1036" },
    { name: "South Africa	", code: "IT" , id: "1120" },
    { name: "Spain", code: "IT" , id: "1002" },
    { name: "Sweden", code: "IT" , id: "1043" },
    { name: "Switzerland", code: "IT" , id: "1053" },
    { name: "United Arab Emirates", code: "IT" , id: "1142" },
    { name: "USA", code: "IT" , id: "1064" },

]